import React from 'react';
import { Backdrop, CircularProgress } from '@material-ui/core';

import PropTypes from 'prop-types';
import { spinnerLoadingSize } from '../../utils/constants';

import { backdrop } from '../../styles/feedbackStyles';

export default function SpinnerLoading({ show }) {
  const feedbackStyles = backdrop();
  return (
    <div>
      <Backdrop className={feedbackStyles.spinnerLoading} open={show}>
        <CircularProgress color='inherit' size={spinnerLoadingSize} />
      </Backdrop>
    </div>
  );
}

// Indica i controla els props que se han de passar al component
SpinnerLoading.propTypes = {
  show: PropTypes.bool.isRequired,
};
